import { URLS } from '@/constants';
import { AccountingProduct } from '@/models/accounting';
import { useUserStore } from '@/piniaStores/user/user.store';
import { AccountingCustomersGet } from '@/services/api/models/accounting';
import session, { createSession } from '@/services/session';

/**
 * Fetches a list of accounting accounts
 * @param {number} companyId for which the customers are added to accounting
 */
export async function getAccountingAccounts(companyId: number) {
  const response = await session.get(`${URLS.ACCOUNTING.ACCOUNTS}/?company=${companyId}`);

  return response.data.results;
}

/**
 * Fetches customers of a company that are added to accounting
 * @param {number} companyId for which the customers are added to accounting
 * @param {number} page pagination number of customer accounting
 */
export async function getAccountingCustomers(companyId: number, page: number) {
  const response = await session.get<AccountingCustomersGet>(
    `${URLS.ACCOUNTING.CUSTOMERS}/?company=${companyId}&page=${page}`,
  );

  return response.data;
}

/**
 * Creates a customer to be mapped to accounting
 * @param {object} data for which to be created
 */
export async function createAccountingCustomer(data: { customer: number; company: number }) {
  const response = await session.post(`${URLS.ACCOUNTING.CUSTOMERS}/?${URLS.CUSTOM_ERROR}`, data);

  return response.data;
}

/**
 * Fetches products of a company that are added to accounting
 * @param {number} companyId for which the products are added to accounting
 */
export async function getAccountingProducts(companyId: number) {
  const response = await session.get(`${URLS.ACCOUNTING.PRODUCTS}/?company=${companyId}`);

  return response.data.results;
}

/**
 * Creates an accounting product
 * @param {AccountingProduct} data for which to be created
 */
export async function createAccountingProduct(data: AccountingProduct) {
  const response = await session.post(`${URLS.ACCOUNTING.PRODUCTS}/?${URLS.CUSTOM_ERROR}`, data);

  return response.data;
}

/**
 * Pushes the invoice to accounting
 * @param {string} orderNumber for which the invoice to be pushed
 */
export async function pushInvoice(orderNumber: string) {
  const externalSession = createSession('');
  const userStore = useUserStore();

  const response = await externalSession.get(
    `/c/${userStore.userActiveCompany?.slug}/${URLS.ACCOUNTING.PUSH_INVOICE}/${orderNumber}/`,
  );

  return response.data;
}
